import { InventoryReportTypeEnum } from './inventory';
import { Site } from './site';
import { SKU } from './sku';

export type Detail<T = SKU> = {
  used?: number;
  beg: number;
  del: number;
  end: number;
  hrate: number;
  lost: number;
  ret: number;
  sku: T;
  unu: number;
};

export type InventoryFormDetails = Array<
  Partial<Detail<string>> & {
    _skuName: string;
  }
>;
export enum InventoryReportStatusEnum {
  IN_REVIEW = 0,
  READY_FOR_IMPACT = 1,
  READY_FOR_INVOICE = 2,
  DONE = 3,
}
export type Report = {
  lost?: number;
  used?: number;
  details: Detail[];
  endDate: string;
  startDate: string;
  name: string;
  site: Site;
  _id: string;
  endingInventoryCount?: string;
  beginningInventoryCount?: string;
  month?: number;
  reportNo?: number;
  year?: number;
  notes?: string;
  summaryNotes?: string;
  invoiceNotes?: string;
  totalOrders?: number;
  totalPickups?: number;
  status?: number;
  reportType: number;
  cokeAdjustment?: number;
  feeAdjustment?: number;
  feeAdjustments?: Array<{ type: string; amount: number }>;
  isSentToClient?: boolean;
};

export type CreateHarvestSummaryPayload = {
  name: string;
  beginningInventoryCount: string | null;
  endingInventoryCount: string | null;
  site: string;
  month: number;
  year: number;
  reportType: InventoryReportTypeEnum;
  startDate?: Date | string;
  endDate?: Date | string;
  status?: InventoryReportStatusEnum;
};

export type Impact = {
  name: string;
  startDate: string;
  endDate: string;
  wd: number;
  co2m: number;
  wc: number;
  er: number;
  cos: number;
  ret: number;
  month: number;
  year: number;
  single_use_items: number;
};

export type ImpactReport = Report & {
  impact: Impact;
};

export type CreateImpactReportPayload = {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  month: number;
  year: number;
  wd: number;
  co2m: number;
  wc: number;
  er: number;
  cos: number;
  single_use_items: number;
};

export type HarvestSummary = {};
